// 万众知识库
const Knowledge = () => import('@/views/school/knowledge/Index')
const KnowledgeSearch = () => import('@/views/school/knowledge/Search')
const ArticleDetail = () => import('@/views/school/knowledge/ArticleDetail')
const Training = () => import('@/views/school/training/Index')
const TrainingDetail = () => import('@/views/school/training/Detail')
import dm from 'kkt-domain'
import { getToken, setToken, setRegisterPhone, setWetchInfo, setShareId } from '@/utils/cookie'
import axios from '@/utils/fetch'

const shouquan = (to, from, next) => {
  axios.get('/user/manager/userinfo').then(res => {
    if (res.data.id) {
      next()
    } else {
      throw 'error'
    }
  }).catch(() => {
    if (to.query.deal_user_id) setShareId(to.query.deal_user_id)
    if (to.query.wxopenid) {
      setToken(to.query.wxopenid)
      setRegisterPhone(to.query.no_phone)
      setWetchInfo({
        wxopenid: to.query.wxopenid,
        contact_name: to.query.contact_name,
        head_group: to.query.head_group,
        head_path: to.query.head_path
      })
    }
    let token = to.query.wxopenid || getToken()
    if (!token) {
      location.href = dm.get() + '/session/login/wxlogin2?successRedirect=' + encodeURIComponent(location.origin + to.fullPath)
    } else {
      next()
    }
  })
}

export default [
  {
    path: '/school/knowledge',
    component: Knowledge,
    meta: {
      title: '万众知识库'
    }
  },
  {
    path: '/school/knowledge/search',
    component: KnowledgeSearch,
    meta: {
      title: '万众知识库'
    }
  },
  {
    path: '/school/knowledge/artdetail',
    component: ArticleDetail,
    meta: {
      title: '详情'
    }
  },
  {
    path: '/school/training',
    component: Training,
    // beforeEnter: shouquan,
    meta: {
      title: '培训课程'
    }
  },
  {
    path: '/school/training/detail',
    component: TrainingDetail,
    beforeEnter: shouquan,
    meta: {
      title: '课程详情'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/school.js